import { render, staticRenderFns } from "./AudioPlayBtn.vue?vue&type=template&id=77370738&scoped=true&"
import script from "./AudioPlayBtn.vue?vue&type=script&lang=ts&"
export * from "./AudioPlayBtn.vue?vue&type=script&lang=ts&"
import style0 from "./AudioPlayBtn.vue?vue&type=style&index=0&id=77370738&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77370738",
  null
  
)

export default component.exports